import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MultipleChoiceContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  marginBottom: 32,
});

export const OptionRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
});

export const OptionLabelCircle = styled(Box)({
  width: 28,
  height: 28,
  borderRadius: '50%',
  border: '1px solid var(--am-border-heavy)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  fontWeight: 600,
  color: 'var(--am-text-secondary)',
  flexShrink: 0,
});

export const DeleteOptionButton = styled(IconButton)(({ theme }) => ({
  color: 'var(--am-text-disabled)',
  flexShrink: 0,
  '&:hover': { color: theme.palette.error.main },
}));

export const AddOptionBox = styled(Box)(({ theme }) => ({
  padding: '10px 16px',
  border: '1.5px dashed var(--am-border-mid)',
  borderRadius: theme.shape.borderRadius,
  fontSize: '13px',
  color: 'var(--am-text-secondary)',
  cursor: 'pointer',
  userSelect: 'none',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
}));

export const TextInputPlaceholder = styled(Box)(({ theme }) => ({
  padding: '12px 16px',
  border: '1.5px dashed var(--am-border-mid)',
  borderRadius: theme.shape.borderRadius,
  fontSize: '14px',
  color: 'var(--am-text-disabled)',
  fontStyle: 'italic',
}));
